import React, {useState} from 'react'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from '../../common/Pagination/Pagination';
import find from "lodash/find";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const ReactTableInvoiceGrid = (props) => {

    const [selectedRows, setSelectedRows] = useState([]);

    const columns = [
        {
            id: "checkbox",
            accessor: "",
            Cell: ({ original }) => {
                return (
                        <label className="checkbox-container">
                            <input type="checkbox"
                                onChange={() => {
                                    const updated = props.selectedServiceRequests.addOrUpdate(
                                        original,
                                        "nResourceInstanceId"
                                    );
                                    props.onSelectServiceRequest(updated);
                                }}
                                checked={
                                    find(props.selectedServiceRequests, {
                                        nResourceInstanceId:
                                            original.nResourceInstanceId,
                                    }) !== undefined
                                }
                            />
                            <span className="table-checkbox"></span>
                        </label>
                        /*<input
                            type="checkbox"
                            className="checkbox"
                            onChange={() => {
                                const updated = props.selectedServiceRequests.addOrUpdate(
                                    original,
                                    "nResourceInstanceId"
                                );
                                props.onSelectServiceRequest(updated);
                            }}
                            checked={
                                find(props.selectedServiceRequests, {
                                    nResourceInstanceId:
                                        original.nResourceInstanceId,
                                }) !== undefined
                            }
                            //checked={this.state.selected[original.firstName] === true}
                            //onChange={() => this.toggleRow(original.firstName)}
                        />*/
                );
            },
            // Header: x => {
            //     return (
            //             /*<input
            //                 type="checkbox"
            //                 className="checkbox"
            //                 checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
            //                 onChange={() => {
            //                 const updated = props.selectedServiceRequests.toggleAll(
            //                     x.data,
            //                     "_original"
            //                 );
            //                 props.onSelectServiceRequest(updated);
            //                 }}
            //                 //checked={this.state.selectAll === 1}
            //                 //ref={input => {
            //                 //	if (input) {
            //                 //		input.indeterminate = this.state.selectAll === 2;
            //                 //	}
            //                 //}}
            //                 //onChange={() => this.toggleSelectAll()}
            //             />*/
            //             <label className="checkbox-container">
            //                 <input type="checkbox"
            //                     checked={props.selectedServiceRequests.length === parseInt(props.pageSize)}
            //                     onChange={() => {
            //                     const updated = props.selectedServiceRequests.toggleAll(
            //                         x.data,
            //                         "_original"
            //                     );
            //                     props.onSelectServiceRequest(updated);
            //                     }}
            //                 />
            //                 <span className="table-checkbox"></span>
            //             </label>
                    
            //     );
            // },
            Header: x => {
                const currentPageKeys = x.data.map(item => item.nResourceInstanceId);
                const allSelectedOnPage = currentPageKeys.every(id =>
                    props.selectedServiceRequests.some(
                        request => request.nResourceInstanceId === id
                    )
                );
        
                const handleToggleAll = () => {
                    let updatedSelections;
        
                    if (allSelectedOnPage) {
                        // Unselect all items on the current page
                        updatedSelections = props.selectedServiceRequests.filter(
                            request => !currentPageKeys.includes(request.nResourceInstanceId)
                        );
                    } else {
                        // Add all items on the current page to the selection
                        const newSelections = x.data.filter(item =>
                            !props.selectedServiceRequests.some(
                                request => request.nResourceInstanceId === item.nResourceInstanceId
                            )
                        );
                        updatedSelections = [...props.selectedServiceRequests, ...newSelections];
                    }
        
                    props.onSelectServiceRequest(updatedSelections);
                };
        
                return (
                    <label className="checkbox-container">
                        <input
                            type="checkbox"
                            checked={allSelectedOnPage}
                            onChange={handleToggleAll}
                        />
                        <span className="table-checkbox"></span>
                    </label>
                );
            },
            sortable: false,
            width: 50
        },  
        {
            id: 'nResourceInstanceId',
            Header: 'Resource Id',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "nResourceInstanceId",
        },
        {
            id: 'sServiceDisplayName',
            Header: 'Service Name',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sServiceDisplayName",
        },
        {
            id: 'sEmailAddress',
            Header: 'Customer Name',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            // accessor: "sEmailAddress",
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
                    
										<div>
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Name:</span>
											{
												original.sFirstName && original.sLastName ?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
                                                        {
                                                            `${original.sFirstName &&
                                                                original.sFirstName 
                                                            }${' '}
                                                            ${original.sLastName &&
                                                                original.sLastName 
                                                            }`
                                                        }
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
                                        <div style={{"clear":"both"}}></div>
										<div  className="conv-mt10">
											<span className="conv-float-left conv-mr18 lpm-service-grid-key">Email:</span>
											{
												original.sEmailAddress?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right"}}>
															
															{
																original.sEmailAddress
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Contact:</span>
											{
												original.sContactNumber?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sContactNumber
															}
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
									</div>
				</>
			),
            // Cell: ({ original }) => (
			// 	<>
			// 		{
			// 			`${original.sFirstName &&
			// 				original.sFirstName 
			// 			}${' '}
			// 			${original.sLastName &&
			// 				original.sLastName 
			// 			}`
			// 		}
			// 	</>
			// ),
        },
        {
            id: 'sPaymentMode',
            Header: 'Transaction Details Name',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sPaymentMode",
            Cell: ({ original }) => (
				<>
					<div className={"conv-float-left"}>
										<div>
											<span className="conv-float-left conv-mr18 lpm-service-grid-key">Mode:</span>
											{
												original.sPaymentMode?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>
															
															{
																original.sPaymentMode
															}
														</span><br></br>
													</>
												)
												:
												("NA")
											}
										</div>
										<div style={{"clear":"both"}}></div>
										<div className="conv-mt10">
										<span className="conv-float-left conv-mr5 lpm-service-grid-key">Payment Id:</span>
											{
												original.sPaymentId?
												(
													<>
														<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{
																original.sPaymentId
															}
														</span>
													</>
												)
												:
												<span className="lpm-service-grid-value conv-mr13 conv-ml10" style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
															{("NA")}
														</span>
											}
										</div>
									</div>
				</>
			),
        },
    ]

  return (
    <>
    {/* <div className="row">
        <button onClick={props.getServiceIDs}>Hello</button>
    </div> */}
    <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">

        <div className="spled-container">
            <div className="service-partner spled-container">
            <ReactTableFixedColumns
						minRows={0}
						data={props.data || []}
						columns={columns}
						manual
						defaultPage={props.page}
						pages={props.pages}
						page={props.page}
						pageSize={props.pageSize}
						sortable={false}
						defaultPageSize={10}
						showPagination={true}
						pageSizeOptions={[10,20,30,50,75,100]}
						onFetchData={(state, instance) => {
							props.onFetchServiceRequests(instance, false);
						}}
						onPageSizeChange={props.onPageSizeOptionChange}
						PaginationComponent={Pagination}
						style={{overflowY: "initial",height: "73vh"}}			
						className="-striped hide-scrollbar"
					/>
            </div>
        </div>
      
    </div>
    </>
  )
}

export default ReactTableInvoiceGrid
